<template>
  <div style="position:relative" v-loading="loading">
    <div class="search-row">
      <el-input v-model="queryParams.privateThemeName" placeholder="活动名称">
        <i slot="suffix" class="el-input__icon el-icon-search icon-search"></i>
      </el-input>
      <el-select v-model="queryParams.channelCode" clearable placeholder="选择渠道">
        <el-option label="CR餐饮" value="CR"></el-option>
        <el-option label="TT传统渠道" value="TT"></el-option>
        <el-option label="KBKC" value="KBKC"></el-option>
        <el-option label="NL夜店" value="NL"></el-option>
      </el-select>
      <el-select v-model="queryParams.orgCode" clearable placeholder="选择区域">
        <el-option :label="item.orgName" :value="item.orgCode" v-for="item in regionOrgList" :key="item.orgId"></el-option>
      </el-select>
      <!-- 开始时间 -->
      <el-date-picker
        class="date-input"
        v-model="queryParams.startTime"
        type="date"
        value-format="yyyy-MM-dd"
        placeholder="开始时间"
        :picker-options="pickerOptionsStart"
        @change="checkStartDate"
      />
      <span style="display:inline-block;text-align:center;margin-left:-10px;margin-right:10px;">-</span>
      <!-- 截止时间 -->
      <el-date-picker
        class="date-input"
        v-model="queryParams.endTime"
        type="date"
        placeholder="截止时间"
        value-format="yyyy-MM-dd"
        :picker-options="pickerOptionsEnd"
        @change="checkEndDate"
      />
      <!-- 选择任务类型 -->
      <el-select
        class="reset-taskType"
        v-model="selectTaskType"
        multiple
        collapse-tags
        clearable
        :popper-append-to-body="false"
        placeholder="选择任务类型"
      >
        <el-option v-for="item in taskTypeList" :key="item.key" :label="item.value" :value="item.key"></el-option>
      </el-select>
      <!-- 选择费用返还方式 -->
      <el-select
        class="reset-feeRefund"
        v-model="selectRefundType"
        multiple
        clearable
        collapse-tags
        :popper-append-to-body="false"
        placeholder="选择费用返还方式"
      >
        <el-option v-for="item in refundTypeList" :key="item.key" :label="item.value" :value="item.key"></el-option>
      </el-select>
      <el-select v-model="queryParams.themeStatus" clearable placeholder="选择活动状态">
        <el-option label="待提交" value="0"></el-option>
        <el-option label="待审核" value="100"></el-option>
        <el-option label="生效中" value="200"></el-option>
        <el-option label="已结束" value="900"></el-option>
      </el-select>
      <el-button class="btn-red" size="small" @click="handleSearch">搜索</el-button>
      <el-button class="btn-reset" size="small" @click="handleReset">重置</el-button>
    </div>
    <div class="handle-box">
      <div class="switch-box">
        <el-switch style="margin-right:20px;" v-model="queryParams.isDisabled" @change="showDisabled" />展示已禁用活动
        <el-switch style="margin:0px 20px 0px 40px;" v-model="queryParams.isSaleBonus" @change="showSaleBonus" />仅查看有交易售点相关活动
      </div>
      <div>
        <el-button class="btn-red" size="small" @click="toConfig">+ 新增活动</el-button>
        <el-button class="btn-reset" size="small" @click="toHistoryPage">查看历史配置</el-button>
      </div>
    </div>
    <div class="content-list" v-if="configList && configList.length">
      <el-table :data="configList" @row-click="toDetail" :row-style="{'cursor': 'pointer'}" @sort-change="sortChange">
        <el-table-column prop="privateThemeName" label="活动名称" align="center" width="170px">
          <template #default="scope">
            <div style="font-size:16px;font-weight:700">
              {{scope.row.privateThemeName}}
            </div>
            <div style="font-size:12px;color:#bfbfbf">{{scope.row.themeName}}</div>
            <div style="font-size:12px;color:#C8102D;font-weight:700" v-if="scope.row.publishStatus === 0">已禁用</div>
          </template>
        </el-table-column>
        <el-table-column prop="channel_code" label="渠道" sortable="custom" align="center" width="80px">
          <template #default="scope">
            <div>{{scope.row.channelName}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="org_code" label="区域" sortable="custom" align="center">
          <template #default="scope">
            <div>{{scope.row.orgName}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="start_date,end_date" label="活动时间" sortable="custom" align="center">
          <template #default="scope">
            <div>{{scope.row.startDate | parseTime('{y}-{m}-{d}')}}</div>至
            <div>{{scope.row.endDate | parseTime('{y}-{m}-{d}')}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="frequency" label="打卡频次（天/次）" align="center">
          <template #default="scope">
            <div>{{scope.row.execDaysCycle}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="date" label="执行任务" align="center">
          <template #default="scope">
            <div v-for="item in scope.row.taskTypeScopeList" :key="item">{{item}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="date" label="费用返还方式" align="center" width="180px">
          <template #default="scope">
            <div v-for="(item, index) in getBonusList(scope.row)" :key="index">{{item}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="date" label="可用预算" align="center">
          <template #default="scope">
            <div v-if="scope.row.tradeBudgetTypeDTO && scope.row.tradeBudgetTypeDTO.tradeBudgetInfoCountDTO">
              <div>{{scope.row.tradeBudgetTypeDTO.tradeBudgetInfoCountDTO.typeName}}</div>
              <div>{{scope.row.tradeBudgetTypeDTO.trCodeName}}</div>
              <div>{{scope.row.tradeBudgetTypeDTO.tradeBudgetInfoCountDTO.availableAmount | thousandSymbol}}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="date" label="活动状态" align="center" width="80px">
          <template #default="scope">
            <div>{{scope.row.themeStatusName}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="date" align="center" width="80px">
          <template #default="scope">
            <el-dropdown trigger="click" class="dropdown">
              <span class="el-dropdown-link" @click.stop="111">
                操作
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu v-if="scope.row.publishStatus == 1" class="row-pop-menu">
                <el-dropdown-item>
                  <div @click="handleUpdate(scope.row)" v-if="scope.row.themeStatus !== 200 && scope.row.themeStatus !== 900">修改</div>
                </el-dropdown-item>
                <el-dropdown-item>
                  <div @click="handleCopy(scope.row)">复制</div>
                </el-dropdown-item>
                <el-dropdown-item>
                  <div @click="handleRemove(scope.row)" v-if="scope.row.themeStatus <= 100">删除</div>
                </el-dropdown-item>
                <el-dropdown-item>
                  <div @click="handleDisable(scope.row)" v-if="scope.row.themeStatus === 200 || scope.row.themeStatus === 900">禁用</div>
                </el-dropdown-item>
              </el-dropdown-menu>
              <el-dropdown-menu v-else>
                <el-dropdown-item>
                  <div @click="handleCopy(scope.row)">复制</div>
                </el-dropdown-item>
                <el-dropdown-item>
                  <div @click="handleEnable(scope.row)">启用</div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="nothing" v-else>当前暂无活动数据，请新增活动!</div>
    <div class="pag-row" v-if="total">
      <el-pagination
        background
        layout="total, prev, pager, next"
        :current-page="queryParams.page"
        :page-size="queryParams.pageSize"
        :total="total"
        @current-change="handleCurrentChange"
        v-if="pageShow"
      />
    </div>
  </div>
</template>

<script>
import tradeApi from '@/api/trade'
export default {
  data () {
    return {
      loading: false,
      total: 1,
      configList: [],
      queryParams: {
        privateThemeName: '',
        channelCode: '',
        orgCode: '',
        page: 1,
        pageSize: 5,
        isDisabled: false,
        themeVersion: '202208',
        taskTypeScope: '',
        bonusTypeScope: '',
        startTime: '', // 开始时间
        endTime: '', // 截止时间
        isSaleBonus: false, // 仅查看有交易售点活动
        themeMethod: '', // 排序方式
        themeCol: '' // 排序字段
      },
      pageShow: true,
      regionOrgList: [],
      pickerOptionsStart: {},
      pickerOptionsEnd: {},
      taskTypeList: [], // 任务类型列表
      refundTypeList: [], // 费用返还方式列表
      selectTaskType: [], // 选中的任务类型
      selectRefundType: [] // 选中的费用返还方式
    }
  },
  mounted () {
    // this.queryParams = JSON.parse(sessionStorage.getItem('regionListSearchForm')) ?? this.queryParams
    this.queryParams.page = 1
    this.queryParams.isDisabled = JSON.parse(sessionStorage.getItem('regionDisabled')) ?? this.queryParams.isDisabled
    this.getRegionConfigList()
    this.getRegionOrgList()
    // 获取任务类型列表
    this.getTaskTypeList()
    // 获取费用返还方式
    this.getRefundTypeList()
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (from.name === 'perfect-region-detail') {
        let obj = JSON.parse(sessionStorage.getItem('regionListSearchForm'))
        vm.queryParams = obj ?? vm.queryParams
        vm.selectTaskType = obj.taskTypeScope ? obj.taskTypeScope.split(',') : []
        vm.selectRefundType = obj.bonusTypeScope ? obj.bonusTypeScope.split(',') : []
      }
    })
  },
  methods: {
    // 获取活动配置列表
    getRegionConfigList () {
      this.loading = true
      // console.log(this.queryParams)
      this.queryParams.taskTypeScope = this.selectTaskType.join(',')
      this.queryParams.bonusTypeScope = this.selectRefundType.join(',')
      tradeApi.getRegionConfigList(this.queryParams).then(res => {
        if (res.data.resultCode === '0') {
          this.loading = false
          this.pageShow = false
          this.configList = res.data.resultData.tradePerfectThemeDefineList
          this.total = res.data.resultData.pageInfo.totalCounts
          this.$nextTick(() => {
            this.pageShow = true
          })
        }
      })
    },
    // 开始时间选择器
    checkStartDate: function (value) {
      // let _this = this
      this.pickerOptionsEnd = {
        disabledDate: time => {
          // console.log(this)
          let startTime = this.queryParams.startTime
          // 截止时间不能小于开始时间
          if (startTime) {
            return time.getTime() <= new Date(startTime).getTime() - 86400000
          }
        }
      }
    },
    // 截止时间选择器
    checkEndDate: function (value) {
      this.pickerOptionsStart = {
        disabledDate: (time) => {
          let endTime = this.queryParams.endTime
          // 开始时间不能大于截止时间
          if (endTime) {
            return time.getTime() >= new Date(endTime).getTime()
          }
        }
      }
    },
    // 搜索
    handleSearch () {
      this.queryParams.page = 1
      this.getRegionConfigList()
    },
    // 显示已禁用
    showDisabled () {
      sessionStorage.setItem('regionDisabled', this.queryParams.isDisabled)
      this.queryParams.page = 1
      this.handleSearch()
    },
    // 显示仅查看有交易售点相关活动
    showSaleBonus () {
      this.handleSearch()
    },
    // 排序
    sortChange (val) {
      // 可以获取{column,prop,order}数据
      // console.log(val)
      this.queryParams.themeMethod = val.order === 'ascending' ? 'asc' : val.order === 'descending' ? 'desc' : ''
      if (val.prop === 'start_date,end_date') {
        let arr = val.prop.split(',')
        if (this.queryParams.themeMethod !== '') {
          arr[0] = arr[0] + ' ' + this.queryParams.themeMethod
        }
        this.queryParams.themeCol = arr.join(',')
      } else {
        this.queryParams.themeCol = val.prop
      }
      this.handleSearch()
    },
    // 重置
    handleReset () {
      // this.queryParams = this.$options.data().queryParams
      this.queryParams.privateThemeName = ''
      this.queryParams.channelCode = ''
      this.queryParams.orgCode = ''
      this.queryParams.themeStatus = ''
      this.queryParams.page = 1
      this.queryParams.startTime = ''
      this.queryParams.endTime = ''
      this.queryParams.taskTypeScope = ''
      this.queryParams.bonusTypeScope = ''
      this.selectTaskType = []
      this.selectRefundType = []
      this.getRegionConfigList()
    },
    // 复制
    handleCopy (rowData) {
      this.$router.push({
        path: '/perfect-region-config',
        query: { type: 'copy', themeDefineId: rowData.themeDefineId, orgCode: rowData.orgCode }
      })
    },
    // 修改活动
    handleUpdate (rowData) {
      this.$router.push({
        path: '/perfect-region-config',
        query: { type: 'update', themeDefineId: rowData.themeDefineId, orgCode: rowData.orgCode }
      })
    },
    // 删除活动
    handleRemove (rowData) {
      this.$confirm(`是否删除活动:  ${rowData.privateThemeName}`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        tradeApi.handleRegionRemove({ themeDefineId: rowData.themeDefineId }).then(res => {
          if (res.data.resultCode === '0') {
            this.$message.success('删除成功')
            this.$router.go(0)
          }
        })
      }).catch(() => {

      })
    },
    // 禁用
    handleDisable (rowData) {
      this.$prompt('请输入禁用备注:', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /\S+/,
        inputErrorMessage: '请输入禁用原因'
      }).then(({ value }) => {
        if (!value) {
          this.$message.warning('请填写禁用原因')
          return
        }
        tradeApi.handleRegionDisable({ themeDefineId: rowData.themeDefineId, processRemark: value }).then(res => {
          if (res.data.resultCode === '0') {
            this.$message.success('禁用成功')
            this.$router.go(0)
          }
        })
      }).catch(() => {

      })
    },
    // 启用
    handleEnable (rowData) {
      this.$prompt('请输入启用备注:', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(({ value }) => {
        tradeApi.handleRegionEnable({ themeDefineId: rowData.themeDefineId, processRemark: value }).then(res => {
          if (res.data.resultCode === '0') {
            this.$message.success('启用成功')
            this.$router.go(0)
          }
        })
      }).catch(() => {

      })
    },
    // 新增活动
    toConfig () {
      this.$router.push({
        path: '/perfect-region-config',
        query: { type: 'new' }
      })
    },
    // region 区域列表
    getRegionOrgList () {
      tradeApi.getRegionOrgList().then(res => {
        if (res.data.resultCode === '0') {
          this.regionOrgList = res.data.resultData.regionList
        }
      })
    },
    getTaskTypeList () {
      let params = {
        name: 'tradeTaskTypeMap'
      }
      tradeApi.getTaskTypeList(params).then(res => {
        if (res.data.resultCode === '0') {
          this.taskTypeList = res.data.resultData.tradeTaskTypeMap
        }
      })
    },
    // 获取费用返还方式列表
    getRefundTypeList () {
      let params = {
        name: 'tradeBonusTypeMap'
      }
      tradeApi.getRefundTypeList(params).then(res => {
        if (res.data.resultCode === '0') {
          this.refundTypeList = res.data.resultData.tradeBonusTypeMap
        }
      })
    },
    // 查看历史配置
    toHistoryPage () {
      this.$router.push({
        path: '/perfect/history-region-list'
      })
    },
    // 分页器
    handleCurrentChange (val) {
      this.queryParams.page = val
      this.getRegionConfigList()
    },
    toDetail (row) {
      sessionStorage.setItem('regionListSearchForm', JSON.stringify(this.queryParams))
      if (row.themeStatus === 0 && row.publishStatus === 1) {
        this.$router.push({
          path: '/perfect-region-config',
          query: { type: 'update', themeDefineId: row.themeDefineId, orgCode: row.orgCode }
        })
      } else {
        this.$router.push({
          path: '/perfect-region-detail',
          query: { themeDefineId: row.themeDefineId }
        })
      }
    },
    // 返还方式数据组合
    getBonusList (data) {
      if (!data.bonusTypeNameScope) {
        return []
      }
      let list = data.bonusTypeNameScope.split(',')
      return list
    },
    // 预算池信息
    getBudgetInfoList (val) {
      let budgetInfo = {}
      val.budgetInfoList.forEach(item => {
        if (item.typeId === val.budgetTypeId) {
          budgetInfo = item
        }
      })
      return budgetInfo
    }
  }
}
</script>

<style lang="scss" scoped>
.search-row {
  // display: flex;
  .el-input {
    width: 170px;
    margin-right: 20px;
    margin-bottom: 15px;
  }
  .el-select {
    width: 170px;
    margin-right: 20px;
    margin-bottom: 15px;
  }
  .el-switch {
    line-height: 36px;
    margin: 0 10px 0 20px;
  }
  .icon-search {
    line-height: 39px !important;
  }
  .reset-taskType {
    width: 170px !important;
  }
  .reset-feeRefund {
    width: 240px !important;
  }
  .date-input {
    width: 170px !important;
    ::v-deep .el-input__icon {
      line-height: 36px !important;
    }
  }
}
.handle-box {
  // position: absolute;
  // right: 0;
  // top: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
}
.btn-reset {
  background-color: #bbb;
  color: #ffffff;
}
.content-list {
  ::v-deep .el-table .cell {
    line-height: 19px;
    font-size: 14px;
  }
  margin-top: 30px;
  .el-dropdown-link {
    color: #409dfe;
    cursor: pointer;
  }
}
.dropdown {
  width: 100%;
  height: 60px;
  span {
    display: block;
    height: 100%;
    width: 100%;
    line-height: 60px;
  }
}
.el-dropdown-menu__item {
  padding: 0;
  div {
    width: 70px;
    text-align: center;
  }
}
.edit-week {
  margin-left: 10px;
  font-size: 18px;
  color: #64d795 !important;
  cursor: pointer;
  .el-icon-edit::before {
    color: #64d795;
  }
}
.exec-week {
  margin-right: 5px;
}
.handle {
  width: 300px;
  margin: 0 auto;
  display: flex;
  justify-content: space-evenly;
}
.input-box {
  display: flex;
  flex-wrap: wrap;
  // flex-basis: 60%;
  margin: 0 auto;
  span {
    font-size: 16px;
    font-weight: 700;
    margin-left: 15px;
  }
  .el-input {
    width: 80px;
    height: 30px;
    line-height: 30px;
    margin-right: 25px;
  }
  .el-input-number--mini {
    width: 80px;
    margin-left: 20px;
    margin-right: 10px;
  }
  &::v-deep .el-input__inner {
    width: 80px;
    padding: 0;
  }
  &::v-deep .el-input-number__decrease,
  &::v-deep .el-input-number__increase {
    display: none;
  }
}
.container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
}
.chooseType {
  flex-basis: 30%;
  width: 125px;
  height: 20px;
  line-height: 20px;
  margin-left: 30px;
  border-radius: 5px;
  padding: 5px;
  text-align: center;
  color: #56b0ff;
  background-color: #eef6fd;
  border: 1px dashed #56b0ff;
  cursor: pointer;
  flex: 0 1 auto;
  flex: 0 0 auto;
  box-sizing: content-box;
}
.add-btn {
  color: #64d795;
  cursor: pointer;
  line-height: 28px;
}
.range-mode,
.fixed-mode {
  margin-bottom: 20px;
}
.fixed-mode {
  position: relative;
  .delete-btn {
    width: 20px;
    height: 20px;
    position: absolute;
    right: 0px;
    top: -9px;
    color: rgb(234, 84, 4);
    font-size: 16px;
    line-height: 20px;
    cursor: pointer;
    z-index: 999;
    text-align: center;
  }
}
.nothing {
  // background-color: #fff;
  text-align: center;
  margin-top: 20px;
  padding: 120px 0;
}
.checkbox-info {
  display: flex;
  // flex-basis: 80%;
  flex-wrap: wrap;
  // padding: 10px 0;
  &::v-deep .el-checkbox-button__inner {
    height: 30px;
    padding: 7px 15px;
    border-radius: 4px;
    margin-right: 25px;
  }
  .checkbox-wrapper {
    position: relative;
    margin-bottom: 20px;
  }
}
.row-pop-menu {
  margin-top: -10px;
}
</style>
